import { render } from "./appPageRace.vue?vue&type=template&id=a7c35026&scoped=true"
import script from "./appPageRace.vue?vue&type=script&lang=js"
export * from "./appPageRace.vue?vue&type=script&lang=js"

import "./appPageRace.vue?vue&type=style&index=0&id=a7c35026&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7c35026"]])

export default __exports__